import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { ZLeaderboardAction } from './models';

const c = initContract();

export const authLeaderboardContract = c.router(
  {
    getPointsBreakdown: {
      method: 'GET',
      path: '/points-breakdown',
      responses: {
        200: z.object({
          breakdown: z.array(
            z.object({
              id: z.string(),
              created_at: z.coerce.date(),
              action: ZLeaderboardAction,
              points: z.number(),
            })
          ),
        }),
      },
    },
    getRankAndPointsTotal: {
      method: 'GET',
      path: '/rank-and-points-total',
      responses: {
        200: z.object({
          rank: z.number().nullable(),
          pointsTotal: z.number(),
          raffleEntries: z.number(),
        }),
        400: c.type<{ message: string }>(),
      },
    },
  },
  {
    pathPrefix: '/auth',
    strictStatusCodes: true,
    baseHeaders: z.object({
      'x-access-token': z.string(),
    }),
    commonResponses: {
      401: c.type<{ message: string; statusCode: 401 }>(),
    },
  }
);
